var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResourceLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12225_27262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#666666"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12225_27262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 26.25L3.75 11.25H26.25L23.75 26.25H6.25ZM12.5 18.75H17.5C17.8542 18.75 18.1513 18.63 18.3913 18.39C18.6304 18.1508 18.75 17.8542 18.75 17.5C18.75 17.1458 18.6304 16.8487 18.3913 16.6087C18.1513 16.3696 17.8542 16.25 17.5 16.25H12.5C12.1458 16.25 11.8492 16.3696 11.61 16.6087C11.37 16.8487 11.25 17.1458 11.25 17.5C11.25 17.8542 11.37 18.1508 11.61 18.39C11.8492 18.63 12.1458 18.75 12.5 18.75ZM7.5 10C7.14583 10 6.84875 9.88042 6.60875 9.64125C6.36958 9.40125 6.25 9.10417 6.25 8.75C6.25 8.39583 6.36958 8.09875 6.60875 7.85875C6.84875 7.61958 7.14583 7.5 7.5 7.5H22.5C22.8542 7.5 23.1508 7.61958 23.39 7.85875C23.63 8.09875 23.75 8.39583 23.75 8.75C23.75 9.10417 23.63 9.40125 23.39 9.64125C23.1508 9.88042 22.8542 10 22.5 10H7.5ZM10 6.25C9.64583 6.25 9.34875 6.13 9.10875 5.89C8.86958 5.65083 8.75 5.35417 8.75 5C8.75 4.64583 8.86958 4.34875 9.10875 4.10875C9.34875 3.86958 9.64583 3.75 10 3.75H20C20.3542 3.75 20.6508 3.86958 20.89 4.10875C21.13 4.34875 21.25 4.64583 21.25 5C21.25 5.35417 21.13 5.65083 20.89 5.89C20.6508 6.13 20.3542 6.25 20 6.25H10Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceLibrary);
export default __webpack_public_path__ + "static/media/resource-library.a01080562e5859e9a7424cab22f135bf.svg";
export { ForwardRef as ReactComponent };